import React, { forwardRef, useImperativeHandle, useRef, useState} from "react";
import { RCCButton, RCCRefModalProps, RCCTooltip } from "react-common-components";
import Modal from "src/components/Modal";
import { useTranslation } from "src/context/Translations/context";
import ListOfActions, { IRefListOfActions } from "src/pages/Actions/Panel/listOfActions";
import IFiltersActionsPanel, { ActionGroupers, IRefActionsPanelModalAddChangeDelete } from "src/pages/Actions/Panel/interface";
import ModalAddChangeDelete from "src/pages/Actions/Panel/components/modalAddChangeDelete";
import CheckPermission from "src/components/CheckPermission";
import { PermissionEnum } from "src/context/Auth/interface";
import { IOccurrence, IRefModalImmediateActions } from "../interface";

const modalImmediateActions : React.ForwardRefRenderFunction<IRefModalImmediateActions> = (_, ref)  => {
	const { translate } = useTranslation();

	const modal = useRef<RCCRefModalProps>(null);


	const listOfActionsRef = useRef<IRefListOfActions>(null);
	const modalsRef = useRef<IRefActionsPanelModalAddChangeDelete>(null);
	const [selectedOccurrence, setSelectedOccurrence] = useState<IOccurrence>({} as IOccurrence);
	const [disabled, setDisabled] = useState(false);

	const onCallbackFunction = useRef<Function | undefined>(undefined);

	useImperativeHandle(ref, () => ({
		actionButtonImmediateActions
	}));

	const actionButtonImmediateActions = async (occurence: IOccurrence, disabledOccurence: boolean, onCallback?: Function) => {
		onCallbackFunction.current = onCallback;
		setDisabled(disabledOccurence);
		async function openModal(){
			modal.current?.openModal();
			setSelectedOccurrence(occurence);
		}
		await openModal();
		queryAction();
	};

	const queryAction = async () => {	
		listOfActionsRef.current?.executeQuery();
	};

	return (
		<>
			<Modal
				ref={modal} 
				header={{
					title: translate("Ações Imediatas"),
					icon: {
						name: "bars"
					},
					subtitle: `${translate("Ocorrência")}: ${selectedOccurrence.fullTitle}`
				}}
				footer= {{
					showSaveButton: false,
					cancelButtonText: translate("Cancelar")
				}}
				withoutForm
			>
				<ListOfActions 
					ref={listOfActionsRef}
					positionOptions="leftEnd"
					filters={{} as IFiltersActionsPanel}
					groupersSelect={{
						group: ActionGroupers.ACTIONS_IMMEDIATE_OCCURENCE,
						delayed: "",
						origin: ""
					}}
					groupers={{
						grouperId: selectedOccurrence.ocb001Id
					}}
					layoutList="card"
					header={{
						showTotal: true,
						button: 
						<>
							{!disabled && (
								<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
									<RCCTooltip
										text={translate("Nova ação")}
										color="purple"
										position="leftEnd"
									>
										<RCCButton
											icon={{name: "plus", color: "#FFF", size: 18}}
											color="purple"
											layout="isRounded"
											onClick={() => { if(!modalsRef.current) return; modalsRef.current.openModalAddOrChange(undefined, () => {
												listOfActionsRef.current?.executeQuery();
												if(onCallbackFunction.current)
													onCallbackFunction.current();
											}, undefined, undefined, {occurrenceId: selectedOccurrence.ocb001Id}); }}
											size="md"
										/>		
									</RCCTooltip>											
								</CheckPermission>
							)}		
						</>
					}}
				/>
			</Modal>
      
			{/* Modal ADD inside risk analysis */}
			<ModalAddChangeDelete ref={modalsRef} />
			
		</>
	);

};


export default forwardRef(modalImmediateActions);
